import { render, staticRenderFns } from "./SelectorShelf.vue?vue&type=template&id=ca0660be&scoped=true&"
import script from "./SelectorShelf.vue?vue&type=script&lang=js&"
export * from "./SelectorShelf.vue?vue&type=script&lang=js&"
import style0 from "./SelectorShelf.vue?vue&type=style&index=0&id=ca0660be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0660be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca0660be')) {
      api.createRecord('ca0660be', component.options)
    } else {
      api.reload('ca0660be', component.options)
    }
    module.hot.accept("./SelectorShelf.vue?vue&type=template&id=ca0660be&scoped=true&", function () {
      api.rerender('ca0660be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/accessories/SelectorShelf.vue"
export default component.exports